import React from 'react'
import {BsJustify} from 'react-icons/bs'
import { useBrand } from '../theme/brand'

function Header({OpenSidebar}) {
  const brand = useBrand()
  return (
    <header className='header'>
        <div className='menu-icon'>
            <BsJustify className='icon' onClick={OpenSidebar}/>
        </div>
          
        <div className="header-title">{brand.name}</div>
    </header>
  )
}

export default Header
